<div class="report-info-wrapper theme-color-primary">
  <div class="info store">
    {{store.name}}
  </div>
  <div class="info type">
    {{type.name}}
  </div>
</div>